import { createSlice, PayloadAction } from '@reduxjs/toolkit'
// import { SetProgressAction } from '../common';

export interface ProgressState {
	loading: boolean;
}
const initialState: ProgressState = {
	loading: false,
};

const progressSlice = createSlice({
  name:'progress',
  initialState,
  reducers:{
    SET_PROGRESS:(state, action:PayloadAction<any>):ProgressState=>{
      return{
        ...state,
				loading: action.payload,
      }
    }
  }
})

export const { SET_PROGRESS } = progressSlice.actions
export default progressSlice.reducer
